export const MERCURE_HUB = process.env.VUE_APP_MERCURE_HUB;
export const MERCURE_JWT = process.env.VUE_APP_MERCURE_JWT;
